export default {
      id: "squad-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#squad-usage",
      toString: function () {
        return this.url;
      }
    }